<template>
    <div>
            <el-form ref="form" :model="form" label-width="300px">
                <el-form-item label="Background Image 1">
                    <upload :isImgDom="true" :imageurl="form.backgroundImage1" @childByValue="childByValue('backgroundImage1',$event)"></upload>
                </el-form-item>
                <el-form-item label="Background Image 2">
                    <upload :isImgDom="true" :imageurl="form.backgroundImage2" @childByValue="childByValue('backgroundImage2',$event)"></upload>
                </el-form-item>
                <el-form-item label="Account Registration">
                    <el-radio-group v-model="form.isEnableAccountRegistration">
                        <el-radio :label="true">Enable</el-radio>
                        <el-radio :label="false">Disable</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Auto Send Announcement & Email">
                    <el-radio-group v-model="form.isEnableAutoSendAnnouncementAndEmail">
                         <el-radio :label="true">Enable</el-radio>
                        <el-radio :label="false">Disable</el-radio>
                    </el-radio-group>
                </el-form-item>
               
            </el-form>
        </div>
</template> 

<script>
    import upload from '@/components/upload'
    export default {
         props:{
            form:{
                type:Object,
                default:function(){}
            }
        },
        components:{upload},
        methods:{
          childByValue(label,value){
              this.form[label]=value
              this.$forceUpdate()
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>